var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3C15.8438 3 19 5.46875 19 8.5C19 11.5312 15.8438 14 12 14C11.0938 14 10.2188 13.875 9.375 13.625L8.90625 13.4688L8.5 13.75C7.78125 14.25 6.6875 14.8438 5.3125 15C5.6875 14.5312 6.21875 13.7188 6.5625 12.8125L6.78125 12.2188L6.375 11.7812C5.46875 10.8125 5 9.6875 5 8.5C5 5.46875 8.125 3 12 3ZM12 2C7.5625 2 4 4.9375 4 8.5C4 10 4.59375 11.375 5.625 12.4688C5.1875 13.6875 4.21875 14.75 4.1875 14.75C3.96875 14.9688 3.9375 15.2812 4.03125 15.5625C4.15625 15.8438 4.4375 16 4.71875 16C6.65625 16 8.15625 15.2188 9.09375 14.5625C10 14.8438 10.9688 15 12 15C16.4062 15 20 12.0938 20 8.5C20 4.9375 16.4062 2 12 2Z",
    fill: "#6C757D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.7e025bf9.svg";
export { ForwardRef as ReactComponent };